import "../css/homeStyles.css";
import React, {Component} from "react";
import CacheBuster from '../CacheBuster';
import { Redirect } from "react-router-dom";
import ReactPlayer from 'react-player';
import DesktopBreakpoint from "../components/responsive_utilities/desktop_breakpoint";
import TelevisionBreakpoint from "../components/responsive_utilities/television_breakpoint";
import TabletBreakpoint from "../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../components/responsive_utilities/phone_breakpoint";
var fishVid = require('../media/fishintv_intro.mp4');
var firebase = require('firebase/app');
require('firebase/database');

var config = {
  apiKey: "AIzaSyDagjpDFyrc-KBdRYVB9Fh3PF100-L7wkQ",
  authDomain: "sancochero-51ea9.firebaseapp.com",
  databaseURL: "https://sancochero-51ea9.firebaseio.com",
  projectId: "sancochero-51ea9",
  storageBucket: "sancochero-51ea9.appspot.com",
  messagingSenderId: "25612294936"
};

if (!firebase.apps.length) {
    firebase.initializeApp(config);
} else {
    firebase.app();
}

class Home2 extends Component {
  
  constructor() {
    super();
    this.state = {
      tournaments: [],
      vidPlaying: true,
      contentVis: 'none',
      isLoading: true,
      width: 0,
      height: 0,
      activeHref: '/videoplayer',
      redirect: false
      }
    this.ref = firebase.database().ref('tournaments').orderByChild('day1Date');
    this.baseRef = firebase.database().ref('/');
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this); 
  }
  
  componentWillMount() {
    this.updateWindowDimensions();
    this.ref.on('value', this.handleTournamentUpdate);
    this.baseRef.child('refresh').on('child_changed', this.reloadPage);
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    this.updateWindowDimensions.off;
    this.ref.off;
    this.baseRef.off;
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
    
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
	
  reloadPage = () => {
    window.location.reload(true);
  }
  
  handleTournamentUpdate = (snapshot) => {
    var tournaments= [];
    snapshot.forEach((snap) => {
      tournaments.push({
        tournamentId: snap.key,
        tournamentName: snap.val().name,
        tournamentLogo: snap.val().logoUri,
        tournamentHref: snap.val().href,
        tourDay1: snap.val().day1Date,
        tourDay2: snap.val().day2Date,
        tourDay3: snap.val().day3Date,
        tourDay4: snap.val().day4Date,
        activate: snap.val().activate
      })
      if(snap.val().activate) {
        this.setState({
            redirect: true,
            activeHref: snap.val().href
        })
      } else {
        setTimeout(() => {
            this.setState({
                redirect: true,
                activeHref: '/videoplayer'
            })
        }, 5000);
      }
    })
      this.setState({
        tournaments 
      });
  }

  render () {
    if (this.state.redirect) {
        return <Redirect to={this.state.activeHref}/>;
    } 
    return (
      <div className="front-bkg">
        <TelevisionBreakpoint>
          <div className="tvContainer" style={{height: this.state.height}}>
            {this.state.isLoading ? <ReactPlayer 
                            url={fishVid}
                            controls={false}
                            preload={'true'}
                            width={this.state.width / 2}
                            height={500}
                            volume={.5}
                            muted={true}
                            loop={true}
                            onEnded={() => {}}
                            playing={true}>
                          </ReactPlayer> : null}
          </div>
        </TelevisionBreakpoint>
        <DesktopBreakpoint>
          <div className="desktopContainer" style={{height: this.state.height}}>
          {this.state.isLoading ? <ReactPlayer 
                            url={fishVid}
                            controls={false}
                            preload={'true'}
                            width={this.state.width / 2}
                            height={500}
                            volume={.5}
                            muted={true}
                            loop={true}
                            onEnded={() => {}}
                            playing={true}>
                          </ReactPlayer> : null}
          </div>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <div className="tabletContainer" style={{height: this.state.height}}>
          {this.state.isLoading ? <ReactPlayer 
                            url={fishVid}
                            controls={false}
                            preload={'true'}
                            width={this.state.width / 2}
                            height={300}
                            volume={.5}
                            muted={true}
                            loop={true}
                            onEnded={() => {}}
                            playing={true}>
                          </ReactPlayer> : null}
          </div>
        </TabletBreakpoint>
        <PhoneBreakpoint>
          <div className="phoneContainer" style={{height: this.state.height}}>
          {this.state.isLoading ? <ReactPlayer 
                            url={fishVid}
                            controls={false}
                            preload={'true'}
                            width={this.state.width}
                            height={200}
                            volume={.5}
                            muted={true}
                            loop={true}
                            onEnded={() => {}}
                            playing={true}>
                          </ReactPlayer> : null}
          </div>
        </PhoneBreakpoint>
      </div> 
    );
  }
}

export default Home2;


// WEBPACK FOOTER //
// ./src/pages/Home2.js